import { connect } from 'react-redux';
import { compose, hoistStatics, withProps } from 'recompose';
import CanMassAction from './CanMassActions';

const mapStateToProps = state => ({
  subscriber: state.settings.subscriber,
  user: state.user.user,
});

const enhance = compose(
  connect(mapStateToProps, null),
  withProps((props) => {
    const { subscriber, user } = props;
    return {
      can: user.type === 1 || subscriber.can_mass_actions === 1,
    };
  }),
);

export default hoistStatics(enhance)(CanMassAction);



// WEBPACK FOOTER //
// ./src/components/list/canMassActions/index.js